"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Main class.
 * generic validations
 * @name Validations
 * @returns {Validations}
 */
class Validations {
    /**
     * Check if value has more than the min length.
     * @name minLength
     * @param val string
     * @param min numeric
     */
    static minLength(val, min) {
        if (!val || (val && val.length < min)) {
            return false;
        }
        return true;
    }
    /**
     * Check if value has less than the max length.
     * @name maxLength
     * @param val string
     * @param max numeric
     */
    static maxLength(val, max) {
        if (!val || (val && val.length > max)) {
            return false;
        }
        return true;
    }
    /**
     * Check if value is a string with posible spaces in between.
     * @name stringWithSpacesBtw
     * @param val string
     */
    static stringWithSpacesBtw(val) {
        const nameRegex = new RegExp(/^([a-zA-Z\xC0-\uFFFF]+(?:[\s.]+[a-zA-Z\xC0-\uFFFF]+)*)$/i);
        if (nameRegex.test(val) == false || !this.minLength(val, 2)) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Check if value is a valid fullname.
     * @name fullName
     * @param val string
     */
    static fullName(val) {
        return this.stringWithSpacesBtw(val);
    }
    /**
     * Check if value is a valid alphanumeric.
     * @name alphaNumeric
     * @param val string
     */
    static alphaNumeric(val, whitespaces) {
        const pattern = whitespaces ? /^[a-zA-ZáÁéÉíÍóÓúÚñÑ0-9\s]*$/ : /^[a-zA-ZáÁéÉíÍóÓúÚñÑ0-9]*$/;
        var result = true;
        if (!pattern.test(val)) {
            result = false;
        }
        return result;
    }
    /**
     * Check if value is a valid number.
     * @name number
     * @param val string
     */
    static number(val) {
        const numberRegex = new RegExp(/^[0-9]*$/);
        if (numberRegex.test(val) == false) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Check if value is a valid phone prefix.
     * @name phonePrefix
     * @param val string
     */
    static phonePrefix(val) {
        const phonePrefixRegex = new RegExp(/^[0-9]{2,5}$/);
        if (phonePrefixRegex.test(val) == false || !this.minLength(val, 2)) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Check if value is a valid phone.
     * @name phone
     * @param val string
     * @param size? numeric
     */
    static phone(val, size) {
        size = size || 6;
        if (!this.number(val) || !this.minLength(val, size)) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Check if value is a valid.
     * @name required
     * @param val string
     */
    static required(val) {
        if (val == undefined || val == null || val == '') {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Check if value is a valid email.
     * @name email
     * @param val string
     */
    static email(val) {
        const patronEmail = new RegExp(/^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*(\+[a-zA-Z0-9-]+)?@[a-zA-Z0-9]+[a-zA-Z0-9.-]+\.[a-zA-Z]{1,6}$/i);
        if (patronEmail.test(val) == false) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Check if value is a valid cuil.
     * @name cuil
     * @param val string
     */
    static cuil(v) {
        if (v) {
            v = v.toString().replace(/-/g, "");
            let r = 0, a = v.split(''), m = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
            if (v && v.length == 11) {
                for (let i = 0; i <= 9; i++) {
                    r += Number(a[i]) * m[i];
                }
                r = (11 - (r % 11));
                if (((r == 11) ? 0 : ((r == 10) ? 9 : r)) == Number(a[10])) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
}
exports.default = Validations;
;
//# sourceMappingURL=validations.js.map